module.exports = __webpack_public_path__ + "img/long-logo.35421c98.svg";